<template>
  <v-container
    id="reference-term-list"
  >
    <v-row>
      <v-col
        cols="8"
        md=8
        class="breadcrumbs"
      >
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>

      <v-col
        cols="4"
        sm="4"
      >
        <div class="text-right">
          <div cols="10" md="1">
            <app-modal-insert-solution
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              :filter="filter"
              @onSave="$emit('reloadSolution')"
            >
              <template v-slot:title>
                Cadastramento de Solução
              </template>
            </app-modal-insert-solution>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="solutions"
          item-key="name"
          class="elevation-1"
        >

 <template v-slot:item.acoes="{ item }">
          <v-row>
            <v-col
              cols="1"
            >
              <app-modal-insert-solution
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  :filter="filter"
                  @onSave="$emit('reloadSolution')"
                >
                  <template v-slot:title>
                    Edição de Solução
                  </template>
                </app-modal-insert-solution>
            </v-col>
          </v-row>
        </template>

        <template v-slot:item.acoes_delete="{ item }">
          <v-row>
            <v-col
              cols="1"
            >

               <app-modal-delete-solution
                  :payload="item"
                  @onDeleteEvidence="$emit('reloadSolution')"
                >
                  <template v-slot:title>
                    Deletar Solução
                  </template>
                </app-modal-delete-solution>
            </v-col>

            <v-col
              cols="1"
            >
            </v-col>
          </v-row>
        </template>

        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertSolution from './ModalInsert'
import AppModalDeleteSolution from './ModalDelete'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AppSolutionList',
  props: {
    filter: { type: Object, required: true },
    solutions: { type: Array, required: true }
  },
  components: {
    AppModalInsertSolution,
    AppModalDeleteSolution
  },
  data () {
    return {
      headers: [
        {
          text: '#',
          value: 'eixoId',
          sortable: false
        },
        {
          text: 'Nome',
          align: 'left',
          value: 'nome'
        },
        {
          text: 'Descricao',
          value: 'descricao'
        },
        {
          text: 'Grupo da Solução',
          value: 'grupoSolucao.nome'
        },
        { text: 'Editar', value: 'acoes', sortable: false },
        { text: 'Excluir', value: 'acoes_delete', sortable: false }
      ],
      breadcrumbs: [
        {
          text: 'Grupos de Soluções',
          disabled: true,
          href: 'termo-referencia'
        },
        {
          text: 'Soluções',
          disabled: true,
          href: 'termo-referencia'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'loading'
    ])
  },
  methods: {
    ...mapActions([
      'setLoading'
    ])
  }
}
</script>

<style lang="scss">@import './style.scss';</style>
